export default {"src":"https://fishbrain.com/_next/static/media/newYork.83f607c8.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};